<template>
  <div
    v-if="isVisible"
    class="fixed bottom-[80px] right-[20px] z-20"
  >
    <div
      class="
        grid size-control cursor-pointer
        items-center justify-center
        rounded-full
        bg-[--v3-checkbox-checkboxactivebordercolor]
        text-white
        transition-all
        duration-200 ease-in-out hover:bg-[--v3-tabview-tabviewheaderactivebg]
        hover:text-[--v3-checkbox-checkboxactivebordercolor]
      "
      @click="scrollToTop"
    >
      <Icon name="angle-up" :width="14" :height="14" />
    </div>
  </div>
  <div v-else />
</template>

<script lang="ts" setup>
import { onBeforeUnmount,onMounted, ref } from 'vue';

import Icon from '@/common/components/atoms/Icon';

const isVisible = ref<boolean>(false);

const toggleVisibility = () => {
  isVisible.value = window.pageYOffset > 300;
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

onMounted(() => {
  window.addEventListener('scroll', toggleVisibility);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', toggleVisibility);
});
</script>
